<template>
  <div class="container">
    <NoticeBox class="-cancel _mt-60 _mb-md-120 _mb-sm-60">
      <NoticeHeader>
        <h1 class="heading">お申し込みキャンセルを受け付けました</h1>
      </NoticeHeader>
      <NoticeBody
        >今後ともau PAY
        スマートローンをお引き立てのほどよろしくお願い申しあげます。</NoticeBody
      >
    </NoticeBox>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";

export default {
  name: "En014",
  components: {
    NoticeHeader,
    NoticeBody,
    NoticeBox,
  },
  setup() {
    setMeta({
      title: "お申し込みをキャンセルしました",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果,契約",
    });
  },
};
</script>

<style scoped></style>
